// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".attention-warning[data-v-abfe4c24]{position:relative;margin-right:20px;padding:20px;border-radius:5px}@media(max-width:767px){.attention-warning[data-v-abfe4c24]{margin-right:10px}}.attention-warning--alert[data-v-abfe4c24]{position:absolute;top:-12px;right:-8px;border-radius:50%;padding:2px}", ""]);
// Exports
module.exports = exports;
